import React from "react";
import { Box } from "@mui/material";
import { tokens, displayFont } from "../theme";

/**
 * One figure in a counter band — the row of four-to-seven numbers that sits
 * under a page header and states where the screen's subject stands.
 *
 * Label above, figure below, an optional line saying what the figure is
 * measured against. The figure is the only thing allowed to be large, and it is
 * tabular-lined so a column of them stays in register as the values change.
 *
 * `tone` colours the figure and nothing else. It is for a number that is itself
 * a problem — two missing punches, one absence — not for decoration: a band
 * where every counter is coloured says nothing, because nothing stands out.
 *
 * Use with `counterRowSx(n)` from the frame layout, which owns how many fit
 * per row and what happens to them on a narrow viewport.
 */
const Counter = ({ label, value, sub, tone }) => (
  <Box
    sx={{
      background: tokens.card,
      border: `1px solid ${tokens.border}`,
      borderRadius: "10px",
      p: "1rem 1.125rem",
      minWidth: 0,
    }}
  >
    <Box
      sx={{
        fontSize: "0.75rem",
        fontWeight: 600,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: tokens.textMuted,
        mb: "0.625rem",
      }}
    >
      {label}
    </Box>
    <Box
      sx={{
        fontFamily: displayFont,
        fontSize: "1.375rem",
        fontWeight: 700,
        lineHeight: 1.15,
        fontVariantNumeric: "tabular-nums",
        color: tone || tokens.text,
      }}
    >
      {value}
    </Box>
    {sub != null && (
      <Box sx={{ fontSize: "0.75rem", color: tokens.textMuted, mt: "0.25rem" }}>{sub}</Box>
    )}
  </Box>
);

export default Counter;
